import Navbar from "../../../components/Navbar/Navbar";
import Sidebar from "../../../components/SideBar/sidebar";
import BasicDetails from "../../../components/Profile/BasicDetails";
import BusinessProof from "../../../components/Profile/BusinessProof";
import ChangePassword from "../../../components/Profile/ChangePassword";
import MySubscription from "../../../components/Profile/MySubscription";
import ShopDetails from "../../../components/Profile/ShopDetails";
import React, { useEffect, useState } from "react";
import image from "../../../assets/Images/roundimage.png";
import noImage from "../../../assets/Images/noImage.jpg";
import { Image } from "antd";
import { Breadcrumb } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import { routes } from "../../../Routes";
import { useSelector } from "react-redux";
import BDODetails from "../../../components/Profile/BDODetails";
import { store } from "../../../Redux/store";
import { useTranslation } from "react-i18next";
import "../../../styles.css";
import {
  GetBankDetails,
  GetRetailerDetails,
} from "../../../API  Functions/ProfileFunctions";
import ShopLocation from "../../../components/Profile/ShopLocation";
import RetailerCommision from "../../../components/Profile/RetailerCommision";
import BankDetails from "../../../components/Profile/BankDetails";
import ETASetup from "../../../components/Profile/ETASetup";
import VatProductsScreen from "../../../components/Setting/VatProductsScreen";
import VATSetup from "../../../components/Profile/VATSetup";
import EtaSecretKeys from "../../../components/Profile/EtaSecretKeys";
import { getInventoryEditResttriction } from "../../../API  Functions/InventoryFunctions";

const Profile = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const store_id = useSelector((state) => state.login?.user?.store_id);
  const company_name = useSelector(
    (state) => state?.login?.user?.result?.company_name
  );
  const selectedStore = useSelector((state) => state?.login?.selectedStore);

  const image_url = useSelector(
    (state) => state?.login?.user?.result?.image_url
  );

  const is_retailer = useSelector(
    (state) => state?.login?.user?.result?.is_retailer
  );

  const isMasterStore = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_master
  );
  const contractType =
    useSelector((state) => state.login.contractType) || "Cashier_Ecom";

  const [retailerData, setretailerData] = useState("");
  const [bankData, setBankData] = useState([]);
  const [isEtaEnable, setIsEtaEnable] = useState(null);

  const [selectedValue, setSelectedValue] = useState("My Profile");

  const [Profile, setprofile] = useState({
    name: "",
    image: "",
  });

  useEffect(() => {
    fetchdetails();
    fetchBankdetails();
  }, []);

  useEffect(()=>{
    CheckUserAcessForInventory();
  },[])

   const CheckUserAcessForInventory = async () => {
        try {
          const res = await getInventoryEditResttriction(user_id);
          if (res?.result?.status_code == 200) {
            setIsEtaEnable(res?.result?.is_eta_enabled);
          }
        } catch (error) {
          console.log(error);
        } finally {
        }
      };

const fetchdetails = () => {
  GetRetailerDetails(user_id).then((result) => {
    if (result) {
      setretailerData(result);
      setprofile({
        name: result?.retailer_details?.company_name,
        image: result?.retailer_details?.logo,
      });

      // Call additional function here
      CheckUserAcessForInventory();
    }
  });
};

  const fetchBankdetails = async () => {
    try {
      const res1 = await GetBankDetails(company_id);
      console.log("res1 ==>", res1);

      if (res1?.data?.result?.status === 200) {
        const banks = res1.data.result.response;
        setBankData(banks);
      } else {
        setBankData([]);
      }
    } catch (error) {
      console.error("Error fetching bank details:", error);
    }
  };

  const payload = {
    user_id: user_id,
    store_id: store_id,
    // access_token:accesstoken
  };

  const handleDataSubmit = () => {
    fetchdetails();
  };

  const data = [
    {
      name: "My Profile",
      component: (
        <BasicDetails
          payload={payload}
          onDataSubmit={handleDataSubmit}
          profiledetail={(val) => setprofile(val)}
          data={retailerData}
          fetchdetails={fetchdetails}
        />
      ),
    },
    {
      name: "shop_details",
      component: (
        <ShopLocation onDataSubmit={handleDataSubmit} data={retailerData} />
      ),
    },

    ...(is_retailer && isMasterStore
      ? [
          {
            name: "Bank Details",
            component: (
              <BankDetails
                onDataSubmit={handleDataSubmit}
                data={bankData}
                onSubmit={fetchBankdetails}
              />
            ),
          },
        ]
      : []),

    {
      name: "business_proof",
      component: (
        <BusinessProof
          payload={payload}
          onDataSubmit={handleDataSubmit}
          data={retailerData}
        />
      ),
    },
//     {
//       name: "ETA Setup",
//       component: (
//         <ETASetup
//           payload={payload}
//           onDataSubmit={handleDataSubmit}
//           profiledetail={(val) => {
//             setprofile(val);
//           }}
//           data={retailerData}
//           fetchdetails={fetchdetails}
//         />
//       ),
//     },
//     {
//       name: "ETA Secret Keys",
//       component: (
//         <EtaSecretKeys
//           payload={payload}
//           onDataSubmit={handleDataSubmit}
//           profiledetail={(val) => {
//             setprofile(val);
//           }}
//           data={retailerData}
//           fetchdetails={fetchdetails}
//         />
//       ),
//     },
//     ...(isEtaEnable ? [
// {
//       name: "Tax Master",
//       component: (
//         <VATSetup
//           payload={payload}
//           // onDataSubmit={handleDataSubmit}
//           // profiledetail={(val) => {
//           //   setprofile(val);
//           // }}
//           data={retailerData}
//           // fetchdetails={fetchdetails}
//         />
//       ),
//     }
//     ] : 
//   [])
//     ,
    ...(contractType !== "Cashier"
      ? [
          {
            name: "myGINNE Commission",
            component: <RetailerCommision />,
          },
        ]
      : []),
  ];

  //
  return (
    <>
      <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto  bg-[#F6F7F9]">
        <Navbar heading="My Profile" Profile={Profile} />
        <div className="overflow-y-auto custom-scrollbar">
          <div className="mx-5 font-extrabold">
            {/* <Breadcrumb
            separator={<DoubleRightOutlined />}
            items={[
              {
                title: t("settings"),
                //  href: routes.settings.profile
              },
              { title: t("profile") },
            ]}
            className="relative top-3"
          /> */}
            {/* <div className="font-semibold text-xl mt-4">{t("my_profile")}</div> */}
          </div>
          <div
            className="mx-3 sm:mx-3 mt-4 mb-10 bg-white rounded-xl overflow-y-auto custom-scrollbar"
            style={{ minWidth: 700 }}
          >
            <div className="flex ">
              {/* <div className="md:w-[24%] pb-6 border-r-2 text-[#929EAE] flex flex-col text-center items-center font-medium text-lg"> */}
              <div
                className={`md:w-[20%] pb-6 text-[#929EAE] flex flex-col ms-4 text-start items-center font-medium text-lg ${
                  i18n.language === "ar" ? "border-s-2" : "border-e-2"
                }`}
              >
                <div className="mt-4 flex flex-col gap-2 justify-center items-center">
                  <img
                    className="h-[85px]  w-[85px] object-cover rounded-full"
                    height={85}
                    width={85}
                    // src={Profile.image ? Profile.image : image}
                    src={
                      retailerData?.retailer_details?.logo
                        ? `${
                            retailerData?.retailer_details?.logo
                          }?time=${new Date().getTime()}`
                        : noImage
                    }
                    alt="profile"
                  />
                  <div className=" text-[#272728] mb-4 ">
                    {retailerData?.retailer_details?.name}
                  </div>
                </div>
                {data.map((val, i) => (
                  <div className="cursor-pointer w-full" key={i}>
                    <div
                      className={`py-3 px-2 text-md ${
                        selectedValue === val.name
                          ? "bg-[#D1F1FC] text-black"
                          : "bg-[white]"
                      }`}
                      onClick={() => setSelectedValue(val.name)}
                    >
                      {t(val.name)}
                    </div>
                  </div>
                ))}
              </div>
              <div className="overflow-y-auto custom-scrollbar w-full sm:w-[76%] mx-auto">
                {data.map((val, i) => (
                  <div
                    key={i}
                    style={{
                      display: val.name === selectedValue ? "block" : "none",
                    }}
                  >
                    {val?.component}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
